export default "/images/19baecd04902aa06b3780dc35e1af312.avif";